const mixin = ({
  data () {
    return {
      dialogVisible: false
    }
  },
  methods: {
    onRefresh: function () {
      this.$router.push({ path: '/404' })
    }
  },
  watch: {
    status: {
      // Verifica alterações no objeto status
      deep: true,
      handler (after, before) {
        // Erro de token inválido
        if (after.statusCode === 401) {
          this.dialogVisible = true
        }

        // Verifica o tipo do status => mutation.type
        switch (after.type) {
          case 'GET_ALL_PERFIL_FAILURE':
          case 'LOAD_CONFIGURADOR_FAILURE':
            this.$router.push('/404')
            break
          case 'LOAD_CONFIGURADOR_SUCCESS':
            if (after.idFuncionalidade) {
              this.$router.push({ path: `/${after.idFuncionalidade}` })
            }
            break
          default:
            break
        }

        // Mensagem de Successo/Erro
        if (after.message) {
          this.$notify[(after.status ? 'success' : 'error')]({
            title: (after.status ? 'Sucesso!' : 'Erro!'),
            dangerouslyUseHTMLString: true,
            message: `${after.message} <br><small>${this.$moment(new Date()).format('DD/MM/YYYY HH:mm:ss')}</small>`,
            showClose: false,
            position: 'top-right',
            duration: 2000,
            customClass: `el-notification-${(after.status ? 'success' : 'error')}`,
            offset: 0
          })
        }
        this.$store.commit('status/UPDATE_REQUEST_STATUS', {})
      }
    }
  }
})

export default mixin
